// extracted by mini-css-extract-plugin
module.exports = {"root":"lXSgZNdZ","timeLabel":"csUdRvLd","asOfLastCloseLabel":"xu62h8y4","marketOpenWrapper":"vkzZxfhR","marketOpenLabel":"BJ6omszg","liveDataLabel":"j8f_vzom"};